import { createSelector } from 'reselect'

const getLessonData = state => state.lessons

const myLibraryLaunchSessionTeamsSelector = (state, presentationUid) => createSelector(
	[getLessonData],
	lessons => {
		const lessonData = lessons[presentationUid]
		return {
			lessonData: {
				thumb: lessonData.data.thumb,
				name: lessonData.data.name,
				author: lessonData.data.author,
				modified_formatted: lessonData.data.modified_formatted,
				size: lessonData.data.size,
				isNew: false,
				highlight: false,
			},
		}
	}
)

export default myLibraryLaunchSessionTeamsSelector
